import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// NBP API: https://api.nbp.pl/api/exchangerates/tables/A?format=json
// We only need currency codes; fallback to a small allow-list if needed.

export interface NbpTableAItem {
  currency: string;
  code: string; // e.g., 'USD'
  mid: number;
}
export interface NbpTableAResponse {
  table: string;
  no: string;
  effectiveDate: string;
  rates: NbpTableAItem[];
}

export const nbpApi = createApi({
  reducerPath: 'nbpApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://api.nbp.pl/api' }),
  endpoints: (builder) => ({
    getCurrencies: builder.query<NbpTableAItem[], void>({
      query: () => '/exchangerates/tables/A?format=json',
      transformResponse: (resp: NbpTableAResponse[]) => resp?.[0]?.rates ?? [],
    }),
  }),
});

export const { useGetCurrenciesQuery } = nbpApi;
